<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
    
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left"/>
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <div>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <h3 class="custom-18px-500 font-color-171717">General Shift Setting</h3>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717">Notification Setting</label>
                                <v-select></v-select>
                            </CCol>
                            <CCol sm="5">
                                <label class="custom-14px-500 font-color-171717 mt-3"></label>
                                <v-select></v-select>
                            </CCol>
                            <CCol sm="2">
                                <div class="text-right mt-4">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                        Save</CButton>
                                </div>
                            </CCol>
                        </CRow>
    
    
                    </div>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="6">
                                <CRow>
                                    <CCol sm="8">
                                        <h3 class="custom-18px-500 font-color-171717">Attendance Location</h3>
                                    </CCol>
                                    <CCol sm="4" class="text-right">
                                        <CButton class="btn-border-blue font-color-0B63F6" @click="openAddLocation"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Create Location</CButton>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
    
                                        <div class="no-data-message text-center" style="margin:15%">
                                            <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                            <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                        </div>
                                    </CCol>
                                </CRow>
    
                            </CCol>
                            <CCol sm="6">
                                <CRow>
                                    <CCol sm="8">
                                        <h3 class="custom-18px-500 font-color-171717">Shift Manager</h3>
                                    </CCol>
                                    <CCol sm="4" class="text-right">
                                        <CButton class="btn-border-blue font-color-0B63F6" @click="openAddShift"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Create Shift</CButton>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Default Shift</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
                                    <CCol sm="10">
                                        <label class="custom-14px-500 font-color-171717 mt-1">Night Shift</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <CSwitch class="float-right" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr" />
                                    </CCol>
    
    
                                </CRow>
                            </CCol>
                        </CRow>
                    </div>
                </CCard>
            </div>
    
    
    
    
        </CCol>
    
        <div v-if="OpenAddShiftLocation" class="popup-all backdrop-all">
            <div class="popup-all1">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create Location</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <CRow class="mt-2">
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Location Name</h3>
    
                                                <CInput type="text" />
    
                                            </CCol>
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Location Address</h3>
    
                                                <CInput type="text" />
    
                                            </CCol>
    
    
    
    
                                        </CRow>
                                    </CCol>
    
                                </CRow>
                            </CCol>
                        </CRow>
    
                        <div class="text-right mt-2">
                            <CRow>
                                <CCol sm="6">
                                    <CButton class="custom-grey-radius font-color-171717" @click="closePopup" block>Cancel</CButton>
                                </CCol>
                                <CCol sm="6">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half" block>
                                        Save</CButton>
                                </CCol>
                            </CRow>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
        <div v-if="OpenAddShiftPolicy" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Create New Shift</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupShift" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-16px-700 font-color-171717 text-left">Shift Information</h3>
                                        <h3 class="custom-14px-500 font-color-171717">Shift Name</h3>
                                        <CInput type="text" />
                                        <h3 class="custom-14px-500 font-color-171717">Shift Description</h3>
                                        <CInput type="text" />
                                        <CRow>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Shift Clock In</h3>
                                                <CInput type="time" />
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Shift Clock Out</h3>
                                                <CInput type="time" />
                                            </CCol>
                                        </CRow>
                                        <h3 class="custom-16px-700 font-color-171717 text-left">Shift Setting</h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Enable employee overwrite setting</h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
    
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Enable employee clock in/out selfie</h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
    
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Enable early & late indicator</h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
    
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Display attendance confirmation before submit</h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
    
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Enable Auto Clock Out</h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
                                        </CRow>
    
    
    
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-16px-700 font-color-171717 text-left">Workday Setting</h3>
                                        <table class="table table-responsive-sm mt-3">
                                            <thead class="bg-0B63F6">
                                                <tr>
                                                    <th>
                                                        <label class="custom-14px-500">Working</label>
                                                    </th>
                                                    <th>
                                                        <label class="custom-14px-500">Full Day</label>
                                                    </th>
                                                    <th>
                                                        <label class="custom-14px-500">Half Day</label>
                                                    </th>
                                                    <th>
                                                        <label class="custom-14px-500">Off Day</label>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody class="bg-F8F8F8">
                                                <tr v-for="(day, index) in days" :key="index" class="font-color-171717">
                                                    <td>{{ day }}</td>
                                                    <td>
                                                        <CInputRadio v-model="workingSchedule[day]" value="full" />
                                                    </td>
                                                    <td>
                                                        <CInputRadio v-model="workingSchedule[day]" value="half" />
                                                    </td>
                                                    <td>
                                                        <CInputRadio v-model="workingSchedule[day]" value="off" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-16px-700 font-color-171717 text-left mt-4">Attendance Location</h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Enable geofencing location
                                                </h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
                                        </CRow>
                                        <h3 class="custom-16px-700 font-color-171717 text-left mt-4">Overtime Setting</h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Enable overtime calculation
                                                </h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-16px-700 font-color-171717 text-left mt-4">Break Setting</h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Enable Break Time
                                                </h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
                                        </CRow>
                                        <h3 class="custom-16px-700 font-color-171717 text-left mt-4">Lateness Setting</h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-14px-500 font-color-171717">Enable lateness calculation

                                                </h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <CSwitch class="float-right mt-1" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" />
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                    <CCol sm="12">
                                        <hr class="custom-hr"/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
    
                        <div class="text-right">
                            <CRow>
                                <CCol sm="6">
                                    <CButton class="custom-grey-radius font-color-171717" @click="closePopup" block>Cancel</CButton>
                                </CCol>
                                <CCol sm="6">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half" block>
                                        Save</CButton>
                                </CCol>
                            </CRow>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
    
    
    
    
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {

            options: {
                perPage: 5,
                pagination: true,
                searchable: true
            },

            OpenAddShiftLocation: false,
            isPopupSuccess: false,

            OpenAddShiftPolicy: false,
            days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],

            // Object to hold the working schedule for each day
            workingSchedule: {
                Monday: '',
                Tuesday: '',
                Wednesday: '',
                Thursday: '',
                Friday: '',
                Saturday: '',
                Sunday: ''
            }





        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();



            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyDetails() {
            try {
                const response = await this.$API.get(this.$GetCompanyDetails, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.company = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyDetailsByInfo() {
            try {
                const response = await this.$API.get(this.$GetCompanyDetails, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.FullName = this.info.name;
                        this.Address = this.info.Address;
                        this.City = this.info.City;
                        this.CompanyTypeName = this.info.CompanyTypeName;
                        this.Country = this.info.Country;
                        this.Email = this.info.Email;
                        this.Fax = this.info.Fax;
                        this.CompanyIndustryType = this.info.IndustryType;
                        this.LogoPath = this.info.LogoPath;
                        this.PhoneNumber = this.info.PhoneNumber;
                        this.Postcode = this.info.Postcode;
                        this.RegistrationNumber = this.info.RegistrationNumber;
                        this.ShortName = this.info.ShortName;
                        this.State = this.info.State;

                        this.SetupSelectedOption();
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch company information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closePopup() {
            this.OpenAddShiftLocation = false;
        },
        openAddLocation() {
            this.OpenAddShiftLocation = true;
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        openAddShift() {
            this.OpenAddShiftPolicy = true;
        },
        closePopupShift() {
            this.OpenAddShiftPolicy = false;
        },
        GoToSetting()
        {
            this.$router.push("Setting");
        }





    }

};
</script>